import { render, staticRenderFns } from "./DetailTemuanInventory.vue?vue&type=template&id=54f42c96&scoped=true&"
import script from "./DetailTemuanInventory.vue?vue&type=script&lang=js&"
export * from "./DetailTemuanInventory.vue?vue&type=script&lang=js&"
import style0 from "./DetailTemuanInventory.vue?vue&type=style&index=0&id=54f42c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f42c96",
  null
  
)

export default component.exports